import { useCurrentFrame, useVideoConfig } from 'remotion';

// Types
import type { DiagonalLineProps } from '../../types';

// Constants
import { LAYOUT_POSITIONS, ROTATION_ANGLE } from '../../constants';

// Utils
import { getEntranceAndFloatAnimation } from '../../utils';

export const DiagonalLine = ({
  animationDelay,
  floatDuration = 5,
  exitOpacity = 1,
}: DiagonalLineProps) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const { translateY, opacity } = getEntranceAndFloatAnimation(
    frame,
    fps,
    animationDelay,
    floatDuration,
    'down',
    'fromBottom',
  );

  return (
    <div
      className="absolute h-full w-1.5 origin-top-left rounded-sm bg-secondary-250"
      style={{
        ...LAYOUT_POSITIONS.diagonalLine,
        transform: `rotate(${ROTATION_ANGLE}) translateY(${translateY}px)`,
        opacity: opacity * exitOpacity,
      }}
    />
  );
};
